<template>
  <div>
    <div class="row">
      <div class="col-lg-6">
        <div class="ibox">
          <div class="ibox-content">

            <form class="form-material">
              <h2>Location Details</h2>

              <div class="margin-20"></div>

              <div v-if="$user.isAdminOrCoordinator" class="form-group-outer">
                <div class="form-group float-label-control">
                  <label for="" class="select-label">User</label>
                  <selectize
                    v-model="user"
                    name="user_id"
                    :options="initialUserOptions"
                    :fetch-results="fetchUserResults">
                  </selectize>
                </div>
              </div>

              <div class="form-group-outer">
                <div class="form-group float-label-control" :class="{ 'has-error': errors.has('name') }">
                  <label for="">Property / Depot name</label>
                  <input
                    :disabled="locationNotEditable"
                    type="text"
                    v-model="name"
                    v-validate="'required'"
                    class="form-control"
                    placeholder="Property / Depot name" name="name"
                    v-float-label>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-4 col-md-3">
                  <div class="form-group-outer">
                    <div class="form-group float-label-control">
                      <label for="">Number</label>
                      <input
                        :disabled="locationNotEditable"
                        type="text"
                        v-model="streetNumber"
                        class="form-control"
                        placeholder="Number"
                        v-float-label>
                    </div>
                  </div>
                </div>
                <div class="col-sm-8 col-md-9">
                  <div class="form-group-outer">
                    <div class="form-group float-label-control">
                      <label for="">Street Name</label>
                      <input
                        type="text"
                        v-model="streetName"
                        class="form-control"
                        placeholder="Street Name"
                        v-float-label
                        :disabled="locationNotEditable">
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group-outer">
                <div class="form-group float-label-control">
                  <label for="">Suburb / Town</label>
                  <input
                    type="text"
                    v-model="suburb"
                    class="form-control"
                    placeholder="Suburb / Town"
                    v-float-label
                    :disabled="locationNotEditable">
                </div>
              </div>

              <div class="form-group-outer">
                <div class="form-group float-label-control">
                  <label for="" class="select-label">State</label>
                  <selectize
                    v-model="state"
                    name="state"
                    :options="stateOptions"
                    class="form-control select2-material-placeholder"
                    :disabled="locationNotEditable">
                  </selectize>
                </div>
              </div>

              <div class="form-group-outer">
                <div class="form-group float-label-control">
                  <label for="">Postcode</label>
                  <input
                    :disabled="locationNotEditable"
                    type="text"
                    v-model="postcode"
                    class="form-control"
                    placeholder="Postcode"
                    v-float-label>
                </div>
              </div>

              <div class="form-group-outer">
                <div class="form-group float-label-control">
                  <label for="">UHF Channel</label>
                  <input
                    type="text"
                    v-model="uhfChannel"
                    class="form-control"
                    placeholder="UHF Channel"
                    v-float-label
                    :disabled="locationNotEditable">
                </div>
              </div>

              <div class="form-group-outer">
                <div class="form-group float-label-control">
                  <label for="">Hours of loading</label>
                  <input
                    type="text"
                    v-model="hoursOfLoading"
                    class="form-control"
                    placeholder="Hours of loading"
                    v-float-label
                    :disabled="locationNotEditable">
                </div>
              </div>

              <h2>Access Instructions</h2>

              <location-photo v-model="file">
                <ladda-button v-if="locationIsEditable" slot="delete" type="danger" :on-click="handleDeletePhoto"><i class="fa fa-trash fa-fw"></i></ladda-button>
              </location-photo>

              <div class="form-group-outer">
                <div class="form-group float-label-control">
                  <label for="">Text Directions</label>
                  <textarea
                    v-model="directions"
                    class="form-control"
                    placeholder="Text Directions"
                    rows="5"
                    style="max-width: 100%" v-float-label
                    :disabled="locationNotEditable">
                  </textarea>
                </div>
              </div>

              <h2>Location Contact</h2>

              <div class="margin-10"></div>

              <div class="form-group-outer">
                <div class="form-group">
                  <div class="checkbox checkbox-primary">
                    <input id="check-terms" class="styled" v-model="useContactDetails" type="checkbox" :disabled="locationNotEditable">
                    <label for="check-terms">
                      Use my contact details
                    </label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-6">
                  <div class="form-group-outer">
                    <div class="form-group float-label-control">
                      <label for="">Primary Contact</label>
                      <input
                        type="text"
                        v-model="contactName"
                        class="form-control"
                        :class="{ 'empty' : !useContactDetails }"
                        placeholder="Name"
                        v-float-label
                        :disabled="locationNotEditable">
                    </div>
                  </div>
                </div>
                <div class="col-xs-6">
                  <div class="form-group-outer">
                    <div class="form-group float-label-control">
                      <label for="">Secondary Contact</label>
                      <input
                        type="text"
                        v-model="secondaryContactName"
                        class="form-control"
                        :class="{ 'empty' : !useContactDetails }"
                        placeholder="Name"
                        v-float-label
                        :disabled="locationNotEditable">
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-xs-6">
                  <div class="form-group-outer">
                    <div class="form-group float-label-control">
                      <label for="">Primary Phone</label>
                      <input
                        type="text"
                        v-model="contactPhone"
                        class="form-control"
                        :class="{ 'empty' : !useContactDetails }"
                        placeholder="Primary Phone"
                        v-float-label
                        :disabled="locationNotEditable">
                    </div>
                  </div>
                </div>
                <div class="col-xs-6">
                  <div class="form-group-outer">
                    <div class="form-group float-label-control">
                      <label for="">Secondary Phone (optional)</label>
                      <input
                        type="text"
                        v-model="contactSecondPhone"
                        class="form-control"
                        placeholder="Secondary Phone (optional)"
                        v-float-label
                        :disabled="locationNotEditable">
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group-outer">
                <div class="form-group float-label-control">
                  <label for="">Email Address</label>
                  <input
                    type="text"
                    v-model="contactEmail"
                    class="form-control"
                    :class="{ 'empty' : !useContactDetails }"
                    placeholder="Email Address"
                    v-float-label
                    :disabled="locationNotEditable">
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="ibox">
          <div class="ibox-content">
            <form class="form-material">
              <location-map></location-map>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div v-if="locationIsEditable">
      <router-link class="btn btn-info" :to="{ name: 'locations.index' }">Cancel</router-link>
      <ladda-button type="success" :on-click="handleSaveLocation">Save Location</ladda-button>
      <ladda-button type="danger" :on-click="handleDelete" v-if="editingExistingLocation">Delete</ladda-button>

      <div class="margin-20"></div>
    </div>
  </div>
</template>

<script>
  import { mapMutations, mapState, mapActions, mapGetters } from 'vuex'
  import { Selectize, LaddaButton } from 'components/forms'
  import { SET_LOCATION_ATTRIBUTE, SET_LOCATION, RESET_LOCATION } from 'vx/mutations'
  import { stateMapper, helpers } from 'mixins/locations'
  import { notify, alert } from 'utils'
  import { cloneDeep } from 'lodash'
  import { states } from 'mixins'
  import LocationPhoto from './Photo'
  import LocationMap from './Map'

  export default {
    mixins: [stateMapper, helpers, states],

    components: {
      Selectize,
      LaddaButton,
      LocationPhoto,
      LocationMap
    },

    data () {
      return {
        dirtyPropertyWatching: 'location',
        initialUserOptions: [],
        file: null,
        useContactDetails: false
      }
    },

    /**
     * On created reset the location, if admin or coordinator we fetch the users, and then we attempt
     * to load an existing location if the route deems it necessary.
     *
     * @return void
     */
    created () {
      this[RESET_LOCATION]()

      if (this.$user.isAdminOrCoordinator) {
        const setInitialUserOptions = () => (this.initialUserOptions = cloneDeep(this.userOptionsWithPublic))

        this.getUsers({ master: true }).then(setInitialUserOptions)
      }

      this.attemptToLoadExistingLocation().then(this.watchForChanges)
    },

    watch: {
      /**
       * Watch the contact details checkbox. If checked we want to prefill with our contact
       * details.
       *
       * @param boolean value
       *
       * @return void
       */
      useContactDetails (value) {
        this.contactName = value ? this.$user.profile.full_name : null
        this.contactPhone = value ? this.$user.mobile : null
        this.contactEmail = value ? this.$user.email : null
      },

      /**
       * When the route changes we need to reset the location because this form is used
       * to create and edit locations. We will also attempt to reload an existing
       * location from the database.
       */
      '$route' () {
        this[RESET_LOCATION]()

        this.attemptToLoadExistingLocation().then(this.watchForChanges)
      }
    },

    computed: {
      ...mapState('location', ['location']),
      ...mapGetters('user', ['userOptionsWithPublic']),

      /**
       * Determine if we are creating a new location.
       *
       * @return boolean
       */
      creatingNewLocation () {
        return this.$route.name === 'locations.create'
      },

      /**
       * Determine if we are editing an existing location.
       *
       * @return boolean
       */
      editingExistingLocation () {
        return this.$route.name === 'locations.edit'
      }
    },

    methods: {
      ...mapMutations('location', [SET_LOCATION_ATTRIBUTE, RESET_LOCATION, SET_LOCATION]),
      ...mapActions('location', [
        'storeLocation',
        'updateLocation',
        'deleteLocation',
        'getLocation',
        'uploadLocationPhoto',
        'deleteLocationPhoto'
      ]),
      ...mapActions('user', ['getUsers']),

      /**
       * When admin types in the user select box we need to fetch more users
       * from the api since the users are paginated.
       */
      fetchUserResults (name, callback) {
        return this.getUsers({ name, master: true }).then(response => {
          callback(this.userOptionsWithPublic)
        })
      },

      /**
       * If we are editing an existing location attempt to load it.
       *
       * @return promise
       */
      attemptToLoadExistingLocation () {
        if (this.editingExistingLocation) {
          const locationNotFound = () => {
            notify.error('This location could be not found.')

            this.$router.push({ name: 'locations.index' })
          }

          return this.getLocation(this.$route.params.id).then(() => {
            if (this.user === null) {
              this.user = ''
            }
          }).catch(locationNotFound)
        }

        return Promise.resolve()
      },

      /**
       * Handle saving a new or existing location.
       *
       * @return Promise
       */
      handleSaveLocation () {
        const reportMissingNameError = () => {
          if (this.errors.has('name')) {
            notify.error('A location property / depot name is required.')
          }
        }

        return this.validateAll().then(() => {
          if (this.editingExistingLocation) {
            const notifyUpdated = () => (notify.success('Location has been saved.'))

            let payload = {
              id: this.location.id,
              payload: this.location
            }

            return this.updateLocation(payload)
                       .then(this.handlePhotoUpload)
                       .then(this.updateLocationState)
                       .then(notifyUpdated)
          } else {
            const notifyCreated = () => (notify.success('Location has been created.'))

            return this.storeLocation(this.location)
                       .then(this.handlePhotoUpload)
                       .then(this.redirectToEditLocation)
                       .then(notifyCreated)
          }
        }).catch(reportMissingNameError)
      },

      /**
       * Handle deleting a location.
       *
       * @return Promise
       */
      handleDelete () {
        return alert.delete({ text: 'Are you sure you want to delete this location?' }).then(() => {
          const redirectToIndex = () => {
            notify.success('Location has been deleted.')

            this.$router.push({ name: 'locations.index' })
          }

          return this.deleteLocation(this.location.id).then(redirectToIndex)
        })
      },

      /**
       * Handle the photo upload.
       *
       * @param object response
       *
       * @return object
       */
      handlePhotoUpload (response) {
        if (this.file) {
          return this.uploadLocationPhoto({ file: this.file, id: response.data.id }).then(response => {
            this.file = null

            return response
          })
        }

        return response
      },

      /**
       * Handle delete button for photos.
       *
       * @return Promise
       */
      handleDeletePhoto () {
        return alert.delete({ text: 'Are you sure you want to delete this photo?' }).then(() => {
          const notifyPhotoDeleted = () => (notify.success('Location photo has been deleted.'))

          return this.deleteLocationPhoto(this.location.id).then(this.updateLocationState).then(notifyPhotoDeleted)
        })
      },

      /**
       * Update the location state with the response data.
       *
       * @param object response
       *
       * @return void
       */
      updateLocationState (response) {
        this[SET_LOCATION](response.data)
      },

      /**
       * Redirect to the edit location after creating/editing a location.
       *
       * @param object response
       *
       * @return void
       */
      redirectToEditLocation (response) {
        this.$router.push({ name: 'locations.edit', params: { id: response.data.id } })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Form.vue?5597b900